import { Box, Divider, Typography } from "@mui/material";
import { routes } from "../../constants/routes";
import { Project } from "../../models/schema";
import { colors } from "../../theme/colors";
import { ButtonVariant } from "../utils/Button";
import NavButton from "../utils/NavButton";
import RenderContent from "../utils/RenderContent";

export type ConnectionType = "LEFT" | "RIGHT" | "TOP" | "BOTTOM" | "START";
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConnectionType = {
  LEFT: "LEFT" as ConnectionType,
  RIGHT: "RIGHT" as ConnectionType,
  TOP: "TOP" as ConnectionType,
  BOTTOM: "BOTTOM" as ConnectionType,
  START: "START" as ConnectionType
};

export const ProjectCard = ({
  project,
  buttonVariant = "primary",
  connect
}: {
  project: Project;
  buttonVariant?: ButtonVariant;
  connect?: Array<ConnectionType>;
}) => {
  const route = `${routes.project}/${project.id}`;

  return (
    <Box sx={{ position: "relative", height: "100%" }}>
      <Box
        sx={{
          position: "relative",
          p: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          border: `1px ${colors.grey2} solid`,
          boxSizing: "border-box",
          height: "100%",
          backgroundColor: colors.white,
          zIndex: 1
        }}>
        <Typography variant="h4" mb={2} sx={{ wordBreak: "break-word" }}>
          {project.title}
        </Typography>
        <Divider sx={{ width: "100%", mt: 3, mb: 6, borderTop: `1px ${colors.grey1} solid` }} />
        <RenderContent content={project.descriptionShort?.json} />
        <Box sx={{ display: "flex", alignItems: "flex-end", flex: 1, mt: 5 }}>
          <NavButton variant={buttonVariant} label={project.callToAction as string} route={route} />
        </Box>
      </Box>
      {(connect?.length || 0) > 0 &&
        connect?.map((direction) => {
          if (direction === ConnectionType.START) {
            return (
              <>
                <Box
                  key={direction}
                  sx={{
                    position: "absolute",
                    backgroundColor: colors.grey2,
                    width: "50%",
                    height: 2,
                    left: "-20%",
                    top: "50%"
                  }}
                />
                <Box
                  key={direction}
                  sx={{
                    position: "absolute",
                    backgroundColor: colors.grey2,
                    width: 2,
                    height: "110%",
                    left: "-20%",
                    top: "-60%"
                  }}
                />
              </>
            );
          }

          return (
            <Box
              key={direction}
              sx={{
                position: "absolute",
                backgroundColor: colors.grey2,
                width: [ConnectionType.TOP, ConnectionType.BOTTOM].includes(direction) ? 2 : "100%",
                height: [ConnectionType.LEFT, ConnectionType.RIGHT].includes(direction)
                  ? 2
                  : "110%",
                left: direction === ConnectionType.LEFT ? "-50%" : "50%",
                top: direction === ConnectionType.TOP ? "-60%" : "50%"
              }}
            />
          );
        })}
    </Box>
  );
};
